import configuration from "../config";
import axios from "./axiosConfiguration";

const endpoint = `${configuration.api_url}fiche-bu`;

export const getMonthlyData = (year, month, buId) => {
  return axios
    .get(`${endpoint}/monthly-data/${year}/${month}/${buId}`)
    .then((response) => {
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const getRateMonthlyData = (year, month, buId) => {
  return axios
    .get(`${endpoint}/rate-monthly-data/${year}/${month}/${buId}`)
    .then((response) => {
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const saveFicheBuData = async (year, month, buId, data) => {
  return axios
    .post(`${endpoint}/${year}/${month}/${buId}`, data)
    .then((response) => {
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const savePrioritiesAndBattlesStatusesData = async (
  year,
  month,
  buId,
  data
) => {
  return axios
    .post(`${endpoint}/statuses/${year}/${month}/${buId}`, data)
    .then((response) => {
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};
